import List from "./Views/List";
import Map from "./Views/Map";
import { useFilterParams } from "@/common/hooks/useFilterParams";

const EstablishmentCompanyList = () => {
  const {filterParams, setFilterParams} = useFilterParams();

  const handleSetView = (text: string) => {
    setFilterParams((prevParams) => ({
      ...prevParams,
      establishmentViewMode: text,
    }));
  };

  return (
    <>
      {
        (filterParams?.establishmentViewMode === "list" || !filterParams.establishmentViewMode) &&
        <List setView={handleSetView} />
      }
      {
        (filterParams?.establishmentViewMode && filterParams?.establishmentViewMode === "map") && (
          <Map
            setView={handleSetView}
            view={filterParams?.establishmentViewMode}
            setFilterParams={setFilterParams}
            filterParams={filterParams}
          />
        )}
    </>
  );
};

export default EstablishmentCompanyList;
